/**
 * while not an actual guard, it does guard user from deletion.
 */
export function promptDeleteMathProblem(): boolean {
  if (prompt("Are you sure you want to delete? Action is irreversible. Type 'yes' to continue") == 'yes') {
    const num1 = getRandomInt(10, 70)
    const num2 = getRandomInt(10, 30)
    let lastCheck = prompt(`You sure? Action is IRREVERSIBLE. Type answer to delete: ${num1} + ${num2} = ?`);
    let answer = num1 + num2;
    if (parseInt(lastCheck || "") == answer) {
      return true;
    } else {
      alert(`That wasn't the correct answer, ${lastCheck} instead of ${answer}... phew. If you still want to delete try again.`);
    }
  } else {
    alert("That wasn't a 'yes'... phew.");
  }
  return false;
}


function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}
